<template>
    <!-- 优惠券/代金券 中奖弹窗 -->
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        :styles="{top: '100px'}">
        <div class="diyModal">
            <div class="diyModalBg"
                :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
                <img :src="diyModalBg[awardObj.bigWheelActivityType-1]">
            </div>
            <div class="awardContent">
                <div v-if="awardObj.bigWheelActivityType != '3'">
                    <div class="awardHead"
                        :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">恭喜您获得</div>
                    <div class="awardName ellipsis"
                        :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">{{awardObj.goodsName || awardObj.rewardName}}</div>
                </div>
                <div v-else>
                    <div class="tiger-head">恭喜您获得</div>
                    <div class="tiger-name ellipsis">{{ awardObj.goodsName || awardObj.rewardName }}</div>
                </div>
                <img :src="diyModalHead[awardObj.bigWheelActivityType-1]"
                    style="width: 100%;">
                <div style="padding: 5px 0;">
                    <img :src="awardObj.imgItem"
                        style="max-width: 180px; max-height: 180px;">
                </div>
                <!-- 代金券样式 -->
                <p v-if="activityObj && activityObj.miniType && activityObj.miniType == '1' && (awardObj.goodsType == '5' || awardObj.rewardType == '5')"
                    class="defaultGray"
                    style="padding: 5px 0 0; font-size: 14px;">有效期：{{ startTime }}-{{ endTime }}</p>
                <p v-if="activityObj && activityObj.miniType && activityObj.miniType == '1' && awardObj.jumpType === '1' && awardObj.singleFlag"
                    style="padding: 5px 0 0; font-size: 14px;">返回Hi荣耀首页</p>
            </div>
            <div class="diyReceive">
                <div v-if="awardObj.goodsType == '3' || awardObj.rewardType == '3'"
                    class="diyModalButton"
                    :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''"
                        src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="loginType == 'wechat'"
                        class="diyModalButtonText">
                        <div v-if="awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="toUse(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                        <div v-else
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="modalCancel()">确认</div>
                    </div>
                    <div v-if="loginType == 'Alipay'"
                        class="diyModalButtonText"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''">
                        <div v-if="awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="toUse(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                        <div v-else
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="modalCancel()">确认</div>
                    </div>
                </div>

                <div v-if="awardObj.goodsType == '5' || awardObj.rewardType == '5'"
                    class="diyModalButton"
                    :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor"
                        src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor"
                        :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''"
                        src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'"
                        class="diyModalButtonBg"
                        :style=getButtonBgStyle></div>
                    <div class="diyModalButtonText"
                        v-if="loginType == 'wechat'">
                        <div v-if="awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="toUse(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                        <div v-else-if="!awardObj.singleFlag"
                            :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''"
                            @click="modalCancel()">确认</div>
                        <div v-if="!miniprogramFlag && usePath"
                            class="wxOpenLaunchWeapp">
                            <wx-open-launch-weapp :id="'launch-btn'"
                                :env-version="env"
                                :username="hiHonorWxAppId"
                                :path="usePath.slice(1)">
                                <script type="text/wxtag-template">
                                    <div style="width: 150px; height: 220px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
								            </script>
                            </wx-open-launch-weapp>
                        </div>
                    </div>
                </div>
            </div>
            <div class="diyClose"
                @click="modalCancel(true)">
                <van-icon name="close" />
            </div>
        </div>
    </van-dialog>
</template>

<script>
import wx from 'weixin-js-sdk';
import { config as configEnv } from '../../../../../commons/config.js';
import { queryNeedNotifyAwardInfo } from '../../../../../commons/commonJudgeIsNeedNotify.js';
import { loadAlipayWebViewScript } from '../../../../../utils/comUtils.js';
import { config } from '@/api/config.js';
import { Dialog, Icon } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
  },
  props: {
    awardObj: Object,
    activityObj: Object,
    modalButtonText: String,
    isLoginFlag: Boolean,
  },
  data() {
    return {
      isVisibility: false,
      modelFormCustom: {},
      loginType: '',
      wxOpenLaunchWeapp: '',
      miniprogramFlag: false,
      diyModalBg: [
        'static/runtime/images/magic/award/diyModalBg.png',
        'static/runtime/images/magic/award/awardBg2.png',
        'static/runtime/images/magic/award/tiger-bj.png',
        'static/runtime/images/magic/award/diyModalBg.png',
      ],
      diyModalHead: [
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
        'static/runtime/images/magic/award/awardBg1.png',
        'static/runtime/images/magic/award/tiger-machine-head-bg.png',
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
      ],
      usePath: '', //去使用-跳转地址(从h5页面打开后要跳转的)
      env: configEnv.env === 'pro' ? 'release' : 'trial', // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
      queryNeedNotityFlag: false, //如果1s内关闭奖品弹窗或者其他操作，则不会查询奖品是否需要订阅到期提醒
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  computed: {
    startTime() {
      return this.awardObj.voucherStartDate && this.awardObj.voucherStartDate.slice(0, 10).split('-').join('.');
    },
    endTime() {
      return this.awardObj.voucherEndDate && this.awardObj.voucherEndDate.slice(0, 10).split('-').join('.');
    },
    getButtonBgStyle() {
      return {
        'background-color': this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
      };
    },
  },
  created() {
    this.loginType = sessionStorage.getItem('loginType');
    let that = this;

    console.log('当前环境------env', this.env);

    if (this.loginType == 'wechat') {
      //判断是否在微信小程序环境
      wx.miniProgram.getEnv(function (res) {
        console.log('微信小程序', res.miniprogram);
        if (res.miniprogram) {
          that.miniprogramFlag = res.miniprogram;
        }
      });
    }

    loadAlipayWebViewScript().then((res) => {
      if (res) {
        //判断是否运行在支付宝小程序环境里
        my.getEnv(function (res) {
          console.log('支付宝小程序', res.miniprogram); //true
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      }
    });

    setTimeout(() => {
      if (!this.miniprogramFlag) {
        // 优惠券跳转
        if (this.activityObj && this.activityObj.miniType && this.activityObj.miniType === '1') {
          this.wxOpenLaunchWeapp = `<wx-open-launch-weapp id="launch-btn" username="${this.hiHonorWxAppId}" env-version="${this.env}" path="subpackages/my/pages/couponList/coupon-list"><template><style>.btn { width: 1000px;height: 100px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
        } else {
          this.wxOpenLaunchWeapp = `<wx-open-launch-weapp id="launch-btn" username="gh_c31414cf312a" env-version="${this.env}" path="pageMyCenter/myCoupon/myCoupon?isActivity=true"><template><style>.btn { width: 1000px;height: 100px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
        }
      }
    }, 500);
  },
  mounted() {},

  methods: {
    openModel(obj) {
      this.isVisibility = true;
      this.queryNeedNotityFlag = true;
      if (this.activityObj.loginType === 'wechat' && this.activityObj.enableMessageNotifications === '1' && obj && obj.businessType) {
        let countDown = 1; //倒计时
        const timerId = setInterval(() => {
          if (countDown === 0) {
            clearInterval(timerId);
            if (this.queryNeedNotityFlag) {
              const params = [
                {
                  goodsType: obj.goodsType, //0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
                  collectionType: obj.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
                  businessId: obj.recordId, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
                  businessType: obj.businessType, //业务类型 12.签到  7.专题活动 9.大转盘
                  goodsId: obj.goodsId,
                  bigWheelActivityType: obj.bigWheelActivityType, // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 => 新盲盒
                  drawWheelType: this.activityObj.drawWheelType, //大转盘抽奖类型 drawWheelType  1 => 普通抽奖   2 => 整点购抽奖   3 => 定时开奖
                },
              ];
              queryNeedNotifyAwardInfo(params, this);
            }
          } else {
            countDown--;
          }
        }, 500);
      }
    },

    modalCancel(flag) {
      this.isVisibility = false;
      this.queryNeedNotityFlag = false;
    },
    // "去使用"按钮跳转 ---只在微信内打开（侯宁）
    // jumpType 0：跳转小程序代金券优惠券列表 1：小程序首页 2：自定义链接（小程序/h5）
    toUse(link, type) {
      this.queryNeedNotityFlag = false;
      this.$emit('nextStep', link, type);
    },
    miniWechatGo() {
      if (this.miniprogramFlag) {
        let url = '';
        if (this.activityObj && this.activityObj.miniType && this.activityObj.miniType === '1') {
          url = '/subpackages/my/pages/couponList/coupon-list';
        } else {
          url = '/pageMyCenter/myCoupon/myCoupon?isActivity=true';
        }
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function () {
            console.log('跳转回小程序的页面fail');
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .diyModal {
      width: 320px;
      // max-width: 694px;
      height: auto;
      margin: auto;
      min-height: 245px;
      padding-bottom: 125px;
      position: relative;
      z-index: 10;
      .tiger-modal-bg {
      }
      .other-modal-bg {
      }
      .diyModalBg {
        width: 100%;
        height: 210px;
        border-radius: 20px;
        position: absolute;
        bottom: 0;
        z-index: -1;
        overflow: hidden;
        &::before {
          content: '';
          width: 98%;
          height: 150px;
          position: absolute;
          bottom: 1px;
          background: #ffffff;
          border-radius: 26px;
        }
        img {
          width: 100%;
          position: absolute;
          bottom: -1px;
        }
      }
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background: #ffffff;
        text-align: center;
        border-radius: 20px 20px 0 0;
        .tiger-head {
          font-family: HYQiHei-FZS;
          font-size: 16px;
          padding: 26px 0 0;
          color: #29231e;
          font-weight: 400;
        }
        .tiger-name {
          font-family: HYQiHei-FZS;
          color: #29231e;
          font-size: 20px;
          margin-top: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .awardHead {
          font-size: 16px;
          padding: 26px 0 0;
          color: #2592f7;
        }
        .awardName {
          color: #2b94f6;
          font-size: 20px;
          margin-top: 5px;
          padding: 0 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .defaultGray {
          color: #666666;
        }
      }
      .tiger-btn {
        font-family: HYQiHei-EES;
        color: #d7324c;
        font-size: 18px;
      }
      .diyReceive {
        width: 100%;
        height: 140px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .tiger-btn-img {
          width: 90% !important;
          height: 80% !important;
        }
        .diyModalButton,
        .blindBoxBtn {
          width: 200px;
          height: 45px;
          margin-top: 54px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          position: relative;
          img,
          .diyModalButtonBg {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .diyModalButtonBg {
            background: #ffffff;
            border-radius: 36px;
          }
          .diyModalButtonText {
            width: 100%;
            height: 100%;
            position: absolute;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            div {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .wxOpenLaunchWeapp {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
            }
          }
        }
        .blindBoxBtn {
          color: #b27d13 !important;
          font-size: 16px;
          height: 36px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/couponModal.vue